import React, { ReactNode } from 'react'

import { UnstyledButton } from '@src/components/Button/Button'
import {
  MainRouteName,
  RoutingParams,
  useAccountRouter,
} from '@src/hooks/useAccountRouter'
import { breakpoints } from '@src/constants/breakpoints'
import { screenResolutionVar } from '@src/models/screenResolution'
import { useReactiveVar } from '@apollo/client'
import { useCheckoutRouter } from '@src/hooks/useCheckoutRouter/useCheckoutRouter'

export const AccountSectionNavButton = <P extends MainRouteName>({
  route,
  children,
  className,
  dataTestId,
  onClick,
}: {
  route?: RoutingParams<P>
  children: ReactNode
  className?: string
  dataTestId?: string
  onClick?: () => void
}) => {
  const { route: currentRoute, setRoute } = useAccountRouter()
  const { width } = useReactiveVar(screenResolutionVar)
  const checkoutRouter = useCheckoutRouter()

  const isActive =
    route &&
    ((currentRoute?.mainRouteName === route?.mainRouteName &&
      !route?.childRouteName) ||
      (currentRoute?.childRouteName &&
        (currentRoute?.mainRouteName === route?.mainRouteName &&
          (currentRoute?.childRouteName ?? null)) ===
          (route?.childRouteName ?? null) &&
        (currentRoute?.pageDataId ?? null) === (route?.pageDataId ?? null)))

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (route) {
      setRoute(route)
      if (
        route.mainRouteName == MainRouteName.LOYALTY &&
        width < breakpoints.tablet
      ) {
        checkoutRouter.reset()
      }
    }
  }

  return (
    <UnstyledButton
      className={`${className ?? ''} ${isActive ? ' active' : ''}`}
      type="button"
      onClick={handleClick}
      data-test-id={dataTestId}
    >
      {children}
    </UnstyledButton>
  )
}
